import { render } from "./EditSubtitlesModal.vue?vue&type=template&id=a8dd8c50&scoped=true"
import script from "./EditSubtitlesModal.vue?vue&type=script&lang=js"
export * from "./EditSubtitlesModal.vue?vue&type=script&lang=js"

import "./EditSubtitlesModal.vue?vue&type=style&index=0&id=a8dd8c50&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8dd8c50"]])

export default __exports__